import React, { useState } from 'react';
import { CheckCircleIcon, ChevronDownIcon, ChevronRightIcon, InfoIcon } from 'lucide-react';
// Mock data for lender offers
const mockOffers = [{
  id: 1,
  lender: 'TD Bank',
  logo: 'https://placehold.co/200x100/2E8B57/FFFFFF?text=TD',
  fixedRates: [{
    term: 1,
    rate: 4.89,
    payment: 2816
  }, {
    term: 3,
    rate: 4.79,
    payment: 2796
  }, {
    term: 5,
    rate: 4.94,
    payment: 2827
  }],
  variableRates: [{
    term: 3,
    rate: 4.45,
    payment: 2731
  }, {
    term: 5,
    rate: 4.55,
    payment: 2751
  }],
  preApproved: true,
  features: ['No prepayment penalty', 'Skip a payment option', 'Portable mortgage']
}, {
  id: 2,
  lender: 'RBC Royal Bank',
  logo: 'https://placehold.co/200x100/00539B/FFFFFF?text=RBC',
  fixedRates: [{
    term: 1,
    rate: 4.94,
    payment: 2827
  }, {
    term: 3,
    rate: 4.84,
    payment: 2806
  }, {
    term: 5,
    rate: 4.99,
    payment: 2837
  }],
  variableRates: [{
    term: 3,
    rate: 4.5,
    payment: 2741
  }, {
    term: 5,
    rate: 4.6,
    payment: 2761
  }],
  preApproved: false,
  features: ['Flexible prepayment options', 'Cash back option', 'Payment vacation']
}, {
  id: 3,
  lender: 'Scotiabank',
  logo: 'https://placehold.co/200x100/FF0000/FFFFFF?text=Scotia',
  fixedRates: [{
    term: 1,
    rate: 4.79,
    payment: 2796
  }, {
    term: 3,
    rate: 4.69,
    payment: 2776
  }, {
    term: 5,
    rate: 4.89,
    payment: 2816
  }],
  variableRates: [{
    term: 3,
    rate: 4.4,
    payment: 2721
  }, {
    term: 5,
    rate: 4.5,
    payment: 2741
  }],
  preApproved: true,
  features: ['Home equity line of credit option', 'Online mortgage management', 'Flexible payment schedule']
}];
export function LenderOffers() {
  const [activeTab, setActiveTab] = useState('fixed');
  const [expandedLender, setExpandedLender] = useState<number | null>(null);
  const toggleLenderDetails = (lenderId: number) => {
    setExpandedLender(expandedLender === lenderId ? null : lenderId);
  };
  return <div className="space-y-6" data-id="element-432">
      <div className="bg-white rounded-lg border border-neutral-200 overflow-hidden" data-id="element-433">
        <div className="p-4 border-b border-neutral-200" data-id="element-434">
          <div className="flex space-x-4" data-id="element-435">
            <button className={`px-4 py-2 text-sm font-medium rounded-md ${activeTab === 'fixed' ? 'bg-primary-100 text-primary-700' : 'text-neutral-600 hover:bg-neutral-100'}`} onClick={() => setActiveTab('fixed')} data-id="element-436">
              Fixed Rate
            </button>
            <button className={`px-4 py-2 text-sm font-medium rounded-md ${activeTab === 'variable' ? 'bg-primary-100 text-primary-700' : 'text-neutral-600 hover:bg-neutral-100'}`} onClick={() => setActiveTab('variable')} data-id="element-437">
              Variable Rate
            </button>
          </div>
        </div>
        <div className="divide-y divide-neutral-200" data-id="element-438">
          {mockOffers.map(lender => <div key={lender.id} className="bg-white hover:bg-neutral-50" data-id="element-439">
              <div className="p-4 cursor-pointer" onClick={() => toggleLenderDetails(lender.id)} data-id="element-440">
                <div className="flex flex-col md:flex-row md:items-center justify-between" data-id="element-441">
                  <div className="flex items-center mb-4 md:mb-0" data-id="element-442">
                    <div className="w-16 h-12 mr-4 flex items-center justify-center bg-neutral-100 rounded" data-id="element-443">
                      <img src={lender.logo} alt={lender.lender} className="max-w-full max-h-full" data-id="element-444" />
                    </div>
                    <div data-id="element-445">
                      <h3 className="text-lg font-medium text-neutral-900" data-id="element-446">
                        {lender.lender}
                      </h3>
                      {lender.preApproved && <span className="inline-flex items-center mt-1 px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800" data-id="element-447">
                          <CheckCircleIcon className="mr-1 h-3 w-3" data-id="element-448" />
                          Pre-approved
                        </span>}
                    </div>
                  </div>
                  <div className="flex items-center space-x-6" data-id="element-449">
                    {activeTab === 'fixed' ? <div className="text-center" data-id="element-450">
                        <p className="text-sm text-neutral-500" data-id="element-451">5-Year Fixed</p>
                        <p className="text-xl font-bold text-neutral-900" data-id="element-452">
                          {lender.fixedRates.find(r => r.term === 5)?.rate}%
                        </p>
                      </div> : <div className="text-center" data-id="element-453">
                        <p className="text-sm text-neutral-500" data-id="element-454">
                          5-Year Variable
                        </p>
                        <p className="text-xl font-bold text-neutral-900" data-id="element-455">
                          {lender.variableRates.find(r => r.term === 5)?.rate}
                          %
                        </p>
                      </div>}
                    <div className="text-center" data-id="element-456">
                      <p className="text-sm text-neutral-500" data-id="element-457">
                        Monthly Payment
                      </p>
                      <p className="text-xl font-bold text-neutral-900" data-id="element-458">
                        $
                        {activeTab === 'fixed' ? lender.fixedRates.find(r => r.term === 5)?.payment : lender.variableRates.find(r => r.term === 5)?.payment}
                      </p>
                    </div>
                    <div data-id="element-459">
                      {expandedLender === lender.id ? <ChevronDownIcon className="h-5 w-5 text-neutral-400" data-id="element-460" /> : <ChevronRightIcon className="h-5 w-5 text-neutral-400" data-id="element-461" />}
                    </div>
                  </div>
                </div>
              </div>
              {expandedLender === lender.id && <div className="p-4 bg-neutral-50 border-t border-neutral-200" data-id="element-462">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-463">
                    <div data-id="element-464">
                      <h4 className="text-sm font-medium text-neutral-700 mb-3" data-id="element-465">
                        Available Terms
                      </h4>
                      <div className="bg-white rounded-md border border-neutral-200 overflow-hidden" data-id="element-466">
                        <table className="min-w-full divide-y divide-neutral-200" data-id="element-467">
                          <thead className="bg-neutral-50" data-id="element-468">
                            <tr data-id="element-469">
                              <th className="px-3 py-2 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-470">
                                Term
                              </th>
                              <th className="px-3 py-2 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-471">
                                Rate
                              </th>
                              <th className="px-3 py-2 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-472">
                                Payment
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-neutral-200" data-id="element-473">
                            {(activeTab === 'fixed' ? lender.fixedRates : lender.variableRates).map((rate, index) => <tr key={index} className="hover:bg-neutral-50" data-id="element-474">
                                <td className="px-3 py-2 whitespace-nowrap text-sm text-neutral-900" data-id="element-475">
                                  {rate.term} Year
                                  {activeTab === 'variable' ? ' Variable' : ' Fixed'}
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap text-sm font-medium text-neutral-900" data-id="element-476">
                                  {rate.rate}%
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap text-sm text-neutral-900" data-id="element-477">
                                  ${rate.payment}/mo
                                </td>
                              </tr>)}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div data-id="element-478">
                      <h4 className="text-sm font-medium text-neutral-700 mb-3" data-id="element-479">
                        Features
                      </h4>
                      <ul className="space-y-2" data-id="element-480">
                        {lender.features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-481">
                            <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0" data-id="element-482" />
                            <span className="text-sm text-neutral-700" data-id="element-483">
                              {feature}
                            </span>
                          </li>)}
                      </ul>
                      <div className="mt-6 flex space-x-3" data-id="element-484">
                        <button className="px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors" data-id="element-485">
                          Apply Now
                        </button>
                        <button className="px-4 py-2 border border-neutral-300 text-neutral-700 rounded-md hover:bg-neutral-50 transition-colors" data-id="element-486">
                          Compare Details
                        </button>
                      </div>
                    </div>
                  </div>
                </div>}
            </div>)}
        </div>
      </div>
      <div className="bg-blue-50 border border-blue-200 rounded-md p-4 flex items-start" data-id="element-487">
        <InfoIcon className="h-5 w-5 text-blue-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-488" />
        <div className="text-sm text-blue-800" data-id="element-489">
          <p className="font-medium mb-1" data-id="element-490">Rate Information</p>
          <p data-id="element-491">
            Rates shown are subject to change without notice. Payments shown are
            estimates based on the mortgage amount, term, and amortization
            period. Actual rates and payments may vary. Contact the lender
            directly for the most current rates and terms.
          </p>
        </div>
      </div>
    </div>;
}